module.exports = __webpack_public_path__ + "img/avatar6.a5a8e87f.png";